//
// DataValue.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";

var DataValue = createModule("commons_DataValue", [47], ClosetObject, [
    ,
    ,
    ,
    {
        stringIndex: 4,
        numericValue: 6,
        formattedValue: 7,
    },
    {
        setStringValue: [0,7,4],
        hasNoValue: [2],
        getStringValue: [7],
        isMissing: [2],
        isMatchesAll: [2],
        isSuppressed: [2],
        isAllOthers: [2],
        isSparse: [2],
        isString: [2],
        getDisplayString: [7],
        getDescription: [7],
    },
    {
        _create_sn: [4,7,4],
        _create_n: [4,6],
        formatNumericValue: [7,6,7],
        formatStringValue: [7,7,4],
        aggregate: [0,[1],[1]],
    },
    ,
    ["_create"]
]);
export default DataValue;
